/* eslint-disable react/no-deprecated */
import { Component } from 'react';
import QuestionDropdown from 'legacy/javascripts/components/question_dropdown.es6.jsx';
import WidgetHeader from 'legacy/javascripts/components/widget_header.es6.jsx';

class WidgetContainer extends Component {
  constructor() {
    super();
    this.style = {
      backgroundColor: 'white',
      boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)',
      borderTop: '2px solid #335168',
      borderLeft: '1px solid rgba(0, 0, 0, 0.09)',
      borderRight: '1px solid rgba(0, 0, 0, 0.09)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.09)',
      margin: '20px 0 20px 0',
    };
  }

  render() {
    let Widget = this.props.widget;

    if (this.props.title) {
      return (
        <div style={this.style} className="trend-chart">
          <div className="js-widget-header">
            {this.props.questions ? (
              <QuestionDropdown
                title={this.props.title}
                summaryCount={this.props.data.summary_count}
                subtitle={this.props.data.subtitle}
                docCount={this.props.data.doc_count}
                filters={this.props.filters}
                questions={this.props.questions}
                onApplyCallback={this.props.onApplyCallback}
              />
            ) : (
              <WidgetHeader
                title={this.props.title}
                summaryCount={this.props.data.summary_count}
                subtitle={this.props.data.subtitle}
                docCount={this.props.data.doc_count}
                shouldNotTranslateSubtitle={
                  this.props.title === 'Additional question'
                }
              />
            )}
          </div>
          {this.props.widget && (
            <div className="js-widget-content">
              <Widget
                type={this.props.widget}
                data={this.props.data}
                handler={this.props.handler}
                chartHandler={this.props.chartHandler}
                filters={this.props.filters}
                {...this.props.widgetProps}
              />
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div style={this.style} className="js-widget-content">
          <Widget
            type={this.props.widget}
            data={this.props.data}
            handler={this.props.handler}
            chartHandler={this.props.chartHandler}
          />
        </div>
      );
    }
  }
}

export default WidgetContainer;
/* eslint-enable react/no-deprecated */
